import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersCheckboxes } from '../../components/search-filters-checkbox/search-filters-checkboxes'

export const NewTransmission = withFacetContext(
    FacetName.transmission,
    withFilterContext(FilterName.transmission, SearchFiltersCheckboxes, {
        title: 'Gearbox',
    })
)
